export default __webpack_public_path__ + "static/media/DeliverSuccess.461bb54d.gif";